package org.multiplatform.kotfolio.pages.kids.exam.grade2

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/kids/exam/grade2/english1")
@Composable
fun CanReadPage() {
    BlogLayout(
        PageProperties(
            "English",
            ""
        ),
        BlogProperties("Try At Home", "English")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            Ul {
                SpanText(
                    text = "Tick(✓) the correct option to complete the sentence.",
                    modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                )

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "When the poet grown up she came in which grade?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )

                            Ul {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    Column {
                                        SpanText(
                                            text = "Rishabh",
                                            modifier = Modifier.fontSize(FontSize.Medium)
                                        )
                                    }
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    Column {
                                        SpanText(
                                            text = "Vedant",
                                            modifier = Modifier.fontSize(FontSize.Medium).color(Colors.Green)
                                        )
                                    }
                                }
                            }
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "What was the name of Sakhi’s brother?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )

                            Ul {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    Column {
                                        SpanText(
                                            text = "Grade 1",
                                            modifier = Modifier.fontSize(FontSize.Medium).color(Colors.Green)
                                        )
                                    }
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    Column {
                                        SpanText(
                                            text = "Grade 2",
                                            modifier = Modifier.fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }
                        }
                    }
                }
            }

            Ul {
                SpanText(
                    text = "Answer the following questions.",
                    modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                )

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "Who reads the book for poet when she was small?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                            SpanText(
                                text = "Poet’s mother reads the book when she was small.",
                                modifier = Modifier.fontSize(FontSize.Medium).color(Colors.Green)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "Why was Sakhi excited?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                            SpanText(
                                text = "Sakhi was excited for her sixth birthday.",
                                modifier = Modifier.fontSize(FontSize.Medium).color(Colors.Green)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "When did Sakhi’s tooth fall off?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                            SpanText(
                                text = "Sakhi’s tooth fall off at the breakfast table.",
                                modifier = Modifier.fontSize(FontSize.Medium).color(Colors.Green)
                            )
                        }
                    }
                }
            }

            Ul {
                SpanText(
                    text = "Capitalise the proper nouns and rewrite the sentences.",
                    modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                )

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "We will go for a trip at dubai.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                            SpanText(
                                text = "We will go for a trip at Dubai.",
                                modifier = Modifier.fontSize(FontSize.Medium).color(Colors.Green)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "karan loves to celebrate diwali with his family. ",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                            SpanText(
                                text = "Karan loves to celebrate Diwali with his family.",
                                modifier = Modifier.fontSize(FontSize.Medium).color(Colors.Green)
                            )
                        }
                    }
                }
            }

            Ul {
              Column {
                  SpanText(
                      text = "Read the passage and answer the questions that follow.",
                      modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                  )

                  SpanText(
                      text = "One misty morning, Chloe and Joey were looking around their backyard. They were sitting on the grass. Joey saw a rock with little plants on it. “Look at that mossy green rock!” Joey cried. “That is not a rock,” Chloe said. “It’s a dinner table for snails.” A snail inched over to the rock to munch on the plants. Next, Joey saw a leaf. “Look at that pretty yellow leaf!” Joey cried. “That is not a leaf,” Chloe said. “It’s a blanket for beetles.” A beetle crawled under the warm leaf. Then, Joey saw a flower. “Look at that red flower!” Joey cried. “That is not a flower,” Chloe said. “It’s a shower for worms.” A worm played in the water under the flower as dewdrops dripped from the petals. “Look at that wild mushroom!” Joey cried. “That is not a mushroom,” Chloe said. “It’s an umbrella for spiders.” A spider knit a web under the mushroom away from the mist. Finally, Joey saw a stick. “Look at that squiggly–” Joey stopped. If he called it a stick, Chloe would say it was not a stick. So, Joey cried, “Look at that squiggly ladybug ladder!” Chloe grinned at Joey and said, “Now you’re seeing things from another point of view!”",
                      modifier = Modifier.fontSize(FontSize.Medium).padding(topBottom = 0.3.em),
                  )
              }

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "What is the meaning of the backyard?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                            SpanText(
                                text = "Open garden area.",
                                modifier = Modifier.fontSize(FontSize.Medium).color(Colors.Green)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "How many creatures do Chloe and Joey see in their backyard?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                            SpanText(
                                text = "Chloe and Joey saw 5 creatures in their backyard.",
                                modifier = Modifier.fontSize(FontSize.Medium).color(Colors.Green)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "What was a shower for worms?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                            SpanText(
                                text = "Red flowers was a shower for worms.",
                                modifier = Modifier.fontSize(FontSize.Medium).color(Colors.Green)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "Where did spider built his web?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                            SpanText(
                                text = "Spider built his web under the Mushroom.",
                                modifier = Modifier.fontSize(FontSize.Medium).color(Colors.Green)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "What does Joey do differently at the end of the story?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                            SpanText(
                                text = "Joey calls a stick a “ladybug ladder” to show Chloe he can see from another viewpoint too.",
                                modifier = Modifier.fontSize(FontSize.Medium).color(Colors.Green)
                            )
                        }
                    }
                }
            }
        }
    }
}